import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestTransferPoint = () => {
  const result = apiClient.get(
    '/user/transfer/point',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export default requestTransferPoint;
